import {createEffectFn} from '@ngneat/effects';
import {catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap} from 'rxjs';

import {suppliersUnitsService} from '@store/suppliers/units/suppliers-units.service';
import {SuppliersUnitsState} from '@store/suppliers/units/suppliers-units.store';

type SearchSuppliersUnitsParams = Partial<SuppliersUnitsState>

export const searchSuppliersUnitsEffect = createEffectFn((params$: Observable<SearchSuppliersUnitsParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => suppliersUnitsService.getSuppliersUnits().pipe(catchError(() => EMPTY))),
  );
});
